export default function Train_Test() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Train/Test</h1>
      <p>Content for Train/Test goes here.</p>
    </div>
  );
}